<template>
  <div>
    <!--    活动列表-->
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
        :cellDbClick="updateRow"
        @toolbar-addData="addRow"
    >
    </x-grid>

    <a-space class="a-form-btn-box">
      <a-button @click="closeAssignPop()">取消</a-button>
      <a-button type="primary" @click="getAssignPopResult">确定</a-button>
    </a-space>

  </div>
</template>

<script>
import {
  GridMixin,
  api,
  fac,
} from "@/utils/common/XGridBase";
// import {dataApi} from '@/services/activityManage/activityList';

//列表接口
const url = api.activity.ACTIVITYCOUNTLIST;

//主键
const rowId = 'acitvityId';

//列
const columns = [
  fac.makeColumnRadioDefault(),
  // fac.makeColumnCheckboxDefault(),
  fac.makeColumn("activityNo", "活动编号", 140),
  fac.makeColumn("activityName", "活动名称", 140),
  fac.makeColumn("activityTypeName", "活动类型", 120, "center"),
  fac.makeColumn("regionDeptName", "经理部", 120, "center"),
  fac.makeColumn("dealerDeptName", "经销商", 140, "center"),
  fac.makeColumn("createUserName", "创建人", 160, "center"),
  fac.makeColumn("activityStartTime", "活动开始时间", 160, "center",),
  fac.makeColumn("activityEndTime", "活动结束时间", 160, "center",),
  fac.makeColumn("createDate", "申请时间", 160, "center",),
]

//筛选项
const formConfig = fac.makeFormConfig(columns, [
  // {field: 'deptNo'},
  // {field: 'parentDeptName'},
  {field: 'activityNo'},//活动编号
  {field: 'activityName'},//活动名称
  {field: 'activityTypeName'},//活动类型

  {field: 'regionDeptName'},//经理部
  {field: 'dealerDeptName'},//经销商
  {field: 'createUserName'},//创建人
  {
    field: 'createDate',
    title: "申请时间",
    type: 'dateRange',
  },
  {
    field: 'activityStartTime',
    title: "活动结束时间",
    type: 'dateRange',
  }
])

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: false,
  delData: false,
  addData: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

async function loadBaseData() {

}

export default {
  mixins: [GridMixin],
  // props: ['transferIdArr'],
  props: {
    transferIdArr: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
    }
  },
  async mounted() {
    // let that = this;
    // setInterval(()=>{
    //   console.log(that.$refs['grid'].$refs['xGrid'].getFormItems())
    // },1000)
  },
  methods: {
    loadBaseData,
    /**
     * 提交数据 分配
     * @param entities
     * @param vm
     * @returns {Promise}
     */
    async getAssignPopResult() {
      let choosedAct = this.$refs['grid'].$refs['xGrid'].getRadioRecord();
      if (!choosedAct) {
        this.$message.error('请选择一条数据');
        return false;
      }
      this.$emit('chooseAct', choosedAct.acitvityId);
    },
    // 取消 关闭弹窗
    closeAssignPop() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>

/*/deep/ .vxe-grid--form-wrapper {*/
/*  display: none;*/
/*}*/

/deep/ .vxe-table--body-wrapper {
  height: 300px !important;
}

/deep/ .vxe-table--empty-placeholder {
  height: 300px !important;
}

</style>
